import { get, post, remove, requestFile } from './request'

export type postFileProps = {
  tableName: string;
  registerId: string;
  name: string;
}

export type uploadFileResponseProps = {
  id: string;
  bucketFileKey: string;
  bucketName: string;
  ext: string;
  name: string;
  referencedTableId: string;
  referencedTableName: string;
}

export type createPreSignFilesUploadRequest = {
  filename: string;
  contentType: string;
  name: string;
  referencedTableId: string;
  referencedTableName: string;
}

export type createPreSignFilesUploadResponse = {
  uploadURL: string;
  id: string;
}


export const postFileAndGetPreSignAxios = async (data: createPreSignFilesUploadRequest) => {
  const response = await post(`/files/presign`, data);
  return response as createPreSignFilesUploadResponse;
}

export const postFileAxios = async (data: FormData, querys: postFileProps) => {
  const response = await requestFile(`/files?referenced_table_id=${querys.registerId}&referenced_table_name=${querys.tableName}&name=${querys.name}`,
    data);

  return response.data as uploadFileResponseProps;
}

export const getFilesLinkAxios = async (bondInsuranceId: string, tableName?: string) => {
  const response = await get(`/bond-insurances/files?bondInsuranceId=${bondInsuranceId}&tableName=${tableName ? tableName : null}`);
  return response;
}

export const deleteFilesLinkAxios = async (fileId: string) => {
  const response = await remove(`/bond-insurances/files?fileId=${fileId}`);
  return response;
}

export const updateFileTypeAxios = async (id: string, registerId: string, oldType: string, newType: string) => {
  return post('/files/update-type', { id, registerId, oldType, newType });
}

export const getFiles = async ({
  tableName,
  registerId,
  name,
}: {
  tableName: string;
  registerId: string;
  name: string;
}) => {
  return get(`/files?referenced_table_id=${registerId}&referenced_table_name=${tableName}&name=${name}`);
}
